import { useEffect } from "react"

export function useCrossTabSync(key, onData) {
    useEffect(() => {
        const stored = localStorage.getItem(key)
        if (stored) onData(stored)

        const channel = new BroadcastChannel("cross-tab-sync")
        channel.onmessage = (e) => {
            if (e.data?.key === key) {
                onData(e.data.value)
            }
        }

        return () => {
            channel.close()
        }
    }, [key, onData])
}

export function broadcastData(key, value) {
    localStorage.setItem(key, value)
    const channel = new BroadcastChannel("cross-tab-sync")
    channel.postMessage({ key, value })
    channel.close()
}
